document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementsByTagName('FORM')[0] as HTMLElement;
  if (form == null) {
    return;
  }

  const formInputOrTextareas = form.querySelectorAll('.emoji-validation');
  if (!formInputOrTextareas.length) {
    return;
  }

  const showEmojiCaution = (input: HTMLElement) => {
    const parentElement = input.parentElement as HTMLElement;
    const emojiCaution = parentElement.querySelector('.emoji-caution') as HTMLElement;
    if (emojiCaution == null) {
      const span = document.createElement('span');
      span.classList.add('emoji-caution');
      span.innerText = '絵文字は未対応のため、使用することができません';
      parentElement.appendChild(span);
    }
  }

  const hideEmojiCaution = (input: HTMLElement) => {
    const parentElement = input.parentElement as HTMLElement;
    const emojiCaution = parentElement.querySelector('.emoji-caution') as HTMLElement;
    if (emojiCaution != null) {
      emojiCaution.remove();
    }
  }

  const emojiValidation = () => {
    var ranges = [
      '\ud83c[\udf00-\udfff]',
      '\ud83d[\udc00-\ude4f]',
      '\ud83d[\ude80-\udeff]',
      '\ud7c9[\ude00-\udeff]',
      '[\u2600-\u27BF]'
    ];
    var reg = new RegExp(ranges.join('|'), 'g');
    [].forEach.call(formInputOrTextareas, formInputOrTextarea => {
      (formInputOrTextarea as HTMLInputElement).addEventListener('keyup', () => {
        const text = (formInputOrTextarea as HTMLInputElement).value;
        if (text.length && text.match(reg)) {
          showEmojiCaution(formInputOrTextarea);
        } else {
          hideEmojiCaution(formInputOrTextarea);
        }
      });
    });
  }

  emojiValidation();
});
